var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2727_222",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H45V45H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2727_222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.502 31.2891C17.6478 31.2891 13.7129 27.354 13.7129 22.5C13.7129 17.6459 17.6478 13.7109 22.502 13.7109C27.3561 13.7109 31.291 17.6459 31.291 22.5C31.291 27.354 27.3561 31.2891 22.502 31.2891ZM22.502 1.31836C10.8036 1.31836 1.32031 10.8017 1.32031 22.5C1.32031 34.1983 10.8036 43.6816 22.502 43.6816C34.2003 43.6816 43.6836 34.1983 43.6836 22.5C43.6836 10.8017 34.2003 1.31836 22.502 1.31836Z",
    fill: "url(#paint0_linear_2727_222)",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 13.7109H41.7769",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0552 26.9931L20.4766 43.584",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8235 26.7832L5.25 10.2016",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 31.2891C17.6459 31.2891 13.7109 27.354 13.7109 22.5C13.7109 17.6459 17.6459 13.7109 22.5 13.7109C27.3541 13.7109 31.2891 17.6459 31.2891 22.5C31.2891 27.354 27.3541 31.2891 22.5 31.2891Z",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2727_222",
    x1: 1.32031,
    y1: 43.6816,
    x2: 43.6836,
    y2: 1.31836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/Chrome.ec124c1d3bdc54b5f7b7de5f01eb7cd5.svg";
export { ForwardRef as ReactComponent };